import { HelpfulVideo } from 'app/components/HelpfulVideo'
import { Container } from 'app/containers/Container'
import { Profile } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import { getBrandHelpers, getBrandInfo } from 'config'
import { IContactInfo, IHelpfulVideo } from 'config/interfaces';
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'
import { Alert, Button, ButtonGroup, Col, FormGroup, Modal, ModalBody, Panel, Row } from 'react-bootstrap'
import { default as InfiniteCalendar, ReactInfiniteCalendarProps } from 'react-infinite-calendar'
import { Link, Redirect } from 'react-router-dom'
import { isNull } from 'util';

interface ISupportContainerState {
  profile: Profile
}

class Support extends Container<{}, ISupportContainerState> {
  state: ISupportContainerState = {
    profile: undefined
  }

  brandInfo = this.getCustomerBrandInfo()

  componentWillMount() {
    this.onAppStateUpdate((appState) => {
      const profile = appState.Profile.get('info')

      const profileIsLoaded = !_.isUndefined(profile)
      if (profileIsLoaded) {
        this.setState({ profile })
      }
    })
  }

  renderAdditionalContacts() {
    if (!this.brandInfo.additionalContactInfo) return null;
    const xx = (info: IContactInfo) => <li>{this.renderContactPhone(info.contactPhone)} {this.renderContactEmail(info.contactEmail)}</li>
    return <div>
      <h5 className="lead">You may also reach us at any of the following:</h5>
      <ul className="lead">
        {_.map(this.brandInfo.additionalContactInfo, xx)}
      </ul>
    </div>
  }

  renderContactEmail(email: string) {
    if (email) {
      const contactEmail = 'mailto:' + email
      return <span> or email <a href={contactEmail}>{email}</a></span>
    }
  }

  renderContactPhone(phone: string) {
    if (phone) {
      const x = 'telno:' + phone.replace(/\D/g, '')
      return <a href={x}>{phone}</a>
    }
  }

  render() {
    const profileIsLoaded = !_.isUndefined(this.state.profile)
    if (!profileIsLoaded) { return null }
    const contactPhone = this.renderContactPhone(this.brandInfo.contactPhone)
    const contactEmail = this.renderContactEmail(this.brandInfo.contactEmail)

    return (
      <form className="container-question">
        <section>
          <section className="material-input-group-lg" id="contact">
            <h1>Need Support?</h1>
            <Row>
              <Col md={6}>
                <h5 className="lead">We understand this can get complicated. Let us know what you're having trouble with and we will do our best to help you. </h5>
                <h5 className="lead">Please contact us via phone: {contactPhone}{contactEmail}.</h5>
                {this.renderAdditionalContacts()}
              </Col>
              <Col md={6}>
                <img className="img-responsive" src="/assets/img/man-laptop.jpg" alt="" />
              </Col>
            </Row>
          </section>

          <footer className="margin-y">
            <a href="#/dashboard" className="backtodash-link">
              <i className="fa fa-fw fa-arrow-left" />
              &nbsp;Back to Dashboard
  </a>
          </footer>
        </section>
      </form>
    )
  }

}

export {
  Support
}



// WEBPACK FOOTER //
// ./src/app/containers/Support/index.tsx